import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/de'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import Multiselect from 'vue-multiselect'
import VueExcelXlsx from 'vue-excel-xlsx'
// Plugins
import GlobalComponents from './gloablComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// router setup
import routes from './routes/routes'

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'

import sidebarLinks from './bgsidebarLinks'
import store from './vuex/store'
import VueCookies from 'vue-cookies'
import VueLogger from 'vuejs-logger'

const options = {
  isEnabled: true,
  logLevel: process.env.NODE_ENV === 'production' ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: false,
  showMethodName: false,
  separator: '',
  showConsoleColors: false
}

Vue.use(VueLogger, options)

// plugin setup
Vue.use(VueExcelXlsx)
Vue.component('multiselect', Multiselect)
Vue.use(VueCookies)
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate)
locale.use(lang)

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  Vue.$log.debug('router.beforeEach ' + from.path + ' - ' + to.path + ' - ' + store.getters.loggedIn + ' - ' + to.params.logout)
  if (to.path === '/logout') {
    store.dispatch('logout').then(() => {
      next('/login')
    })
  }
  if (to.matched.some(record => record.meta.requiresAuth) && !store.getters.loggedIn) {
    store.dispatch('logout').then(() => {
      next('/login')
    })
  }
  next()
})

Vue.mixin({
  methods: {
    isSPMUser () {
      return this.$store.state.user && this.$store.state.user.email &&
        (this.$store.state.user.email.includes('@spm.de') ||
          this.$store.state.user.email.includes('@sportplatz-media.com') ||
          this.$store.state.user.email.includes('@spm.spm'))
    },
    getPositionName (pos) {
      if (pos === 1) {
        return 'Startseite/Dashboard'
      }
      return ''
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})



// WEBPACK FOOTER //
// ./src/main.js